const initialState = {
  data: {},
  action: null,
  hierarchies: [],
  affiliateTypes: [],
  retirementsTypes: [],
  relationshipTypes: [],
  affiliateRetirementTypes: [],
  title: 'Cambiar estado del expediente',
  isError: false,
};

const Model = {
  namespace: 'changeFileStateModal',
  state: initialState,
  effects: {
    *setAction({ payload }, { put }) {
      yield put({
        type: 'save',
        payload,
      });
    },

    *setIsError({ payload }, { put }) {
      yield put({
        type: 'save',
        payload: { isError: payload },
      });
    },

    *clean({ payload }, { put }) {
      yield put({
        type: 'clear',
        payload,
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },

    clear() {
      return initialState;
    },
  },
};
export default Model;
